import type { TFunction } from 'i18next';

import { isSkillType } from '@gmm/ui';

// Needed since a skill can be in multiple folders in the same collection
// especially prevalent in colleagues/work
const skillIdentifierDelimiter = ':::';

export const CREATE_EXAM_PATH = '/create/exam';
export const CREATE_ASSIGNMENT_PATH = '/create/assignment';
export interface IdentifiableItem {
  id: string;
  parentId: string | null;
  type: string;
}

export const getTranslatedLabel = (
  t: TFunction,
  key: string,
  fallback: string,
): string => {
  const translated = t(key);

  return typeof translated === 'string' && translated !== key
    ? translated
    : fallback;
};

export const getTranslatedLabelWithOptions = (
  t: TFunction,
  key: string,
  fallback: string,
  options: Record<string, unknown>,
): string => {
  const translated = t(key, options);

  return typeof translated === 'string' && translated !== key
    ? translated
    : fallback;
};

export const getIdentifier = <T extends IdentifiableItem>(item: T): string =>
  isSkillType(item)
    ? `${item.parentId}${skillIdentifierDelimiter}${item.id}`
    : item.id;

export const isSkillIdentifier = (id: string): boolean =>
  id.indexOf(skillIdentifierDelimiter) > -1;
